import GoogleOneTapSignIn from "components/auth/GoogleOneTapSignIn";
import Disclaimers from "components/landing/Disclaimers";
import Link from "next/link";
import * as React from "react";
import getBaseUrl from "../../lib/utils/getBaseUrl";
import mediaQueries from "../../lib/utils/layout/mediaQueries";
import * as palette from "../palette";
import Footer from "./Footer";
import Header from "./Header";

export default function Landing() {
  return (
    <div
      css={{
        padding: "32px 0px",
      }}
    >
      <GoogleOneTapSignIn />

      <div
        css={{
          maxWidth: 1140,
          margin: "0px auto",
        }}
      >
        <Header />
      </div>

      <main
        css={{
          marginTop: 30,
          position: "relative",
          display: "grid",
          gridTemplateColumns: "1fr",
          gridRowGap: 36,
        }}
      >
        <section
          css={mediaQueries({
            position: "relative",
            "&:before": {
              position: "absolute",
              top: 0,
              right: 0,
              left: 0,
              zIndex: -1,
              width: "100%",
              height: "100%",
              backgroundColor: palette.mariner,
              content: '""',
              clipPath: "polygon(0 0, 100% 0%, 100% 100%, 0 70%)",
            },
          })}
        >
          <div
            css={mediaQueries({
              display: "grid",
              gridColumnGap: 30,
              gridTemplateColumns: ["1fr", "1fr", "1fr", "repeat(12, 1fr)"],
              justifyContent: "center",
              padding: ["0px 30px", "0px 30px", "0px 30px", 0],
              maxWidth: 1140,
              margin: "0px auto",
            })}
          >
            <div
              css={mediaQueries({
                gridColumn: "span 6",
                padding: "36px 0px",
                display: "grid",
                gridRowGap: 28,
                textAlign: ["center", "center", "center", "left"],
              })}
            >
              <div
                css={{
                  display: "grid",
                  gridTemplateColumns: "repeat(6, 1fr)",
                }}
              >
                <div
                  css={mediaQueries({
                    gridColumn: ["span 6", "span 6", "span 6", "span 5"],
                  })}
                >
                  <h1
                    css={mediaQueries({
                      margin: 0,
                      color: palette.white,
                      fontWeight: [900, 900, 900, 900],
                      fontSize: [18, 18, 18, 21],
                      lineHeight: 1.33,
                      letterSpacing: 1,
                      textTransform: "uppercase",
                    })}
                  >
                    Análise Fundamentalista de Ações, Stocks e Fundos Imobiliários
                  </h1>
                </div>
              </div>

              <p
                css={mediaQueries({
                  color: palette.white,
                  fontWeight: 300,
                  fontSize: [14, 14, 14, 16],
                  lineHeight: 1.66,
                  letterSpacing: 1,
                  margin: 0,
                })}
              >
                Site completo com acesso imediato a mais de 5.000 ativos, indispensável para investidores que aplicam o
                Buy&Hold!
              </p>

              <div
                css={{
                  display: "grid",
                  gridTemplateColumns: "repeat(6, 1fr)",
                }}
              >
                <div
                  css={mediaQueries({
                    gridColumn: ["span 6", "span 6", "span 6", "span 4"],
                  })}
                >
                  <Link href="/sign-up">
                    <a
                      href="/sign-up"
                      css={{
                        display: "inline-block",
                        boxSizing: "border-box",
                        width: "100%",
                        margin: 0,
                        padding: "12px 0px",
                        overflow: "visible",
                        color: palette.white,
                        fontWeight: 500,
                        fontSize: 14,
                        lineHeight: 1.33,
                        letterSpacing: 1,
                        textAlign: "center",
                        textTransform: "uppercase",
                        textDecoration: "none",
                        backgroundColor: palette.keppel,
                        borderRadius: 28,
                        boxShadow: "rgba(78, 101, 127, 0.5) 0px 8px 24px 0px",
                        transition: "all 60ms ease 0s",
                        userSelect: "none",
                        "&:hover, &:focus": {
                          backgroundColor: palette.downy,
                          outline: "none",
                        },
                        WebkitAppearance: "none",
                      }}
                    >
                      Quero me Cadastrar
                    </a>
                  </Link>
                </div>
              </div>
            </div>

            <div
              css={mediaQueries({
                display: ["none", "none", "none", "block"],
                position: "relative",
                gridColumn: "span 6",
              })}
            >
              <div
                css={{
                  position: "absolute",
                  top: -24,
                  left: 0,
                  width: "100%",
                }}
              >
                <img
                  alt="Fundamentei"
                  draggable={false}
                  onContextMenu={(event) => event.preventDefault()}
                  onMouseDown={(event) => event.preventDefault()}
                  role="presentation"
                  src="/static/app-illustrations--screener.svg"
                  css={{
                    userSelect: "none",
                    position: "relative",
                    maxHeight: 364,
                  }}
                />
              </div>
            </div>
          </div>
        </section>

        <KeyFeatures />

        <WhoAreWe />

        <hr
          css={{
            width: "100%",
            maxWidth: 1140,
            margin: "0px auto",
            border: "none",
            borderBottom: `solid 2px ${palette.mystic}`,
          }}
        />

        <Footer />

        <hr
          css={{
            width: "100%",
            maxWidth: 1140,
            margin: "0px auto",
            border: "none",
            borderBottom: `solid 2px ${palette.mystic}`,
          }}
        />

        <Disclaimers />
      </main>
    </div>
  );
}

interface IKeyFeatureProps {
  feature: string;
  description: string;
}

function KeyFeature({ feature, description }: IKeyFeatureProps) {
  return (
    <div
      css={mediaQueries({
        display: "grid",
        gridTemplateColumns: ["auto-fit", "auto-fit", "auto-fit", "max-content 1fr"],
        gridColumnGap: 30,
        gridRowGap: 30,
        padding: ["0px 30px", "0px 30px", "0px 30px", 0],
        textAlign: ["center", "center", "center", "left"],
      })}
    >
      <div className="flex justify-center">
        <DuetoneCheckmark />
      </div>

      <div
        css={{
          display: "grid",
          gridRowGap: 12,
        }}
      >
        <h5
          css={{
            margin: 0,
            color: palette.blueBayoux,
            fontWeight: "bold",
            fontSize: 14,
            lineHeight: 1.33,
            letterSpacing: 1,
            textTransform: "uppercase",
          }}
        >
          {feature}
        </h5>

        <p
          css={{
            margin: 0,
            color: palette.blueBayoux,
            fontWeight: 300,
            fontSize: 14,
            lineHeight: 1.33,
            letterSpacing: 1,
          }}
        >
          {description}
        </p>
      </div>
    </div>
  );
}

function KeyFeatures() {
  return (
    <section
      css={{
        display: "grid",
        gridRowGap: 36,
        gridTemplateColumns: "1fr",
        maxWidth: 1140,
        margin: "0px auto",
      }}
    >
      <div>
        <h1
          css={mediaQueries({
            margin: 0,
            color: palette.blueBayoux,
            fontWeight: "bold",
            fontSize: [18, 21, 21, 21],
            lineHeight: 1.33,
            letterSpacing: 1,
            textAlign: ["center", "center", "center", "left"],
            textTransform: "uppercase",
          })}
        >
          Quais são as vantagens?
        </h1>
      </div>

      <div
        css={mediaQueries({
          display: "grid",
          gridRowGap: 30,
          gridColumnGap: 30,
          gridTemplateColumns: ["repeat(2, 1fr)", "repeat(12, 1fr)", "repeat(12, 1fr)", "repeat(12, 1fr)"],
          justifyContent: "center",
        })}
      >
        <div
          css={{
            gridColumn: "span 6",
            display: "grid",
            gridRowGap: 16,
          }}
        >
          <ul
            css={{
              margin: 0,
              padding: 0,
              listStyle: "none",
              display: "grid",
              gridRowGap: 36,
            }}
          >
            <li>
              <KeyFeature
                feature="Análise Fundamentalista"
                description="Analise de forma rápida e objetiva os balanços de milhares de empresas e fundos imobiliários."
              />
            </li>

            <li>
              <KeyFeature
                feature="Análise Gráfica"
                description="Veja como as empresas desempenharam historicamente olhando as cotações mais antigas."
              />
            </li>

            <li>
              <KeyFeature
                feature="Análise em Vídeo"
                description="Vídeo exclusivo com a análise fundamentalista de diversas ações e fundos imobiliários."
              />
            </li>
          </ul>
        </div>

        <div
          css={{
            gridColumn: "span 6",
            display: "grid",
            gridRowGap: 16,
          }}
        >
          <ul
            css={{
              margin: 0,
              padding: 0,
              listStyle: "none",
              display: "grid",
              gridRowGap: 36,
            }}
          >
            <li>
              <KeyFeature
                feature="Ranking de Ações, Stocks e FIIs"
                description="Veja quais são os melhores ativos de acordo com a avaliação dos usuários do site."
              />
            </li>

            <li>
              <KeyFeature
                feature="Dados das Empresas"
                description="Veja de forma simplificada o Código de Negociação, Atividade, Segmento de Listagem, Tag Along e Posição Acionária."
              />
            </li>

            <li>
              <KeyFeature
                feature="Dados dos Fundos Imobiliários"
                description="Veja de forma simplificada o tipo do fundo, a distribuição dos ativos, as taxas, os ativos e localização dos imóveis."
              />
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}

function DuetoneCheckmark(props: React.SVGProps<any>) {
  return (
    <svg width={37} height={28} {...props}>
      <g fill="none">
        <path
          fill="#2F4EDA"
          d="M36.46 5.864L19.166 23.443l-5.247-5.317L31.238.553a1.828 1.828 0 012.601-.01l.01.01 2.61 2.655a1.9 1.9 0 010 2.656z"
          opacity={0.4}
        />
        <path
          fill="#627BEA"
          d="M19.161 23.45l-3.935 4a1.825 1.825 0 01-2.601.01l-.01-.01L.613 15.247a1.899 1.899 0 010-2.655l2.611-2.655a1.824 1.824 0 012.596-.012l.012.012 13.33 13.512z"
        />
      </g>
    </svg>
  );
}

function WhoAreWe() {
  return (
    <section
      css={mediaQueries({
        display: "grid",
        gridColumnGap: 30,
        gridRowGap: 30,
        gridTemplateColumns: ["1fr", "1fr", "1fr", "repeat(12, 1fr)"],
        justifyContent: "center",
        maxWidth: 1140,
        margin: "0px auto",
        padding: "36px 30px",
        textAlign: ["center", "left", "left", "left"],
      })}
    >
      <div
        css={{
          gridColumn: "span 6",
        }}
      >
        <div
          css={{
            display: "grid",
            gridRowGap: 16,
          }}
        >
          <h1
            css={mediaQueries({
              margin: 0,
              color: palette.blueBayoux,
              fontWeight: "bold",
              fontSize: 18,
              lineHeight: 1.33,
              letterSpacing: 1,
              textTransform: "uppercase",
            })}
          >
            Sobre nós
          </h1>

          <p
            css={mediaQueries({
              margin: 0,
              color: palette.blueBayoux,
              fontWeight: 300,
              fontSize: [14, 16],
              lineHeight: 1.66,
              letterSpacing: 1,
            })}
          >
            Acreditamos que o Buy&Hold seja o método de investimento que mais se sustenta no longo prazo na Bolsa de
            Valores. O Fundamentei é a união dos nossos esforços para que você tenha em um único site o acesso a todas
            as informações que consideramos essenciais para você escolher os melhores ativos com foco no longo prazo.
          </p>
        </div>
      </div>

      <div
        css={{
          display: "grid",
          gridRowGap: 28,
          gridColumn: "span 6",
        }}
      >
        <div
          css={mediaQueries({
            display: "grid",
            gridTemplateColumns: ["1fr", "max-content 1fr", "max-content 1fr", "max-content 1fr"],
            gridColumnGap: 20,
            gridRowGap: 20,
          })}
        >
          <div className="flex justify-center">
            <img
              src={`${getBaseUrl()}/static/people/eduardo.jpg`}
              alt="Eduardo Cavalcanti"
              className="h-16 w-16 rounded-3xl object-cover"
              width={64}
              height={64}
            />
          </div>

          <div
            css={{
              display: "grid",
              gridRowGap: 8,
            }}
          >
            <h4
              css={{
                margin: 0,
                color: palette.blueBayoux,
                fontWeight: "bold",
                fontSize: 16,
                lineHeight: 1.33,
                letterSpacing: 1.4,
              }}
            >
              Eduardo Cavalcanti
            </h4>

            <p
              css={{
                margin: 0,
                color: palette.blueBayoux,
                fontSize: 14,
                fontStyle: "italic",
                lineHeight: 1.66,
                letterSpacing: 1,
              }}
            >
              Pós-graduado em Finanças, Investimentos e Banking pela PUCRS, é especialista em Mercado de Capitais
              (ANBIMA), Consultor de Valores Mobiliários (CVM) e Analista de Valores Mobiliários (APIMEC). Criador do
              método Investidor Águia, exclusivo para investidores adeptos à filosofia Buy&Hold.
            </p>
          </div>
        </div>

        <div
          css={mediaQueries({
            display: "grid",
            gridTemplateColumns: ["1fr", "max-content 1fr", "max-content 1fr", "max-content 1fr"],
            gridColumnGap: 20,
            gridRowGap: 20,
          })}
        >
          <div className="flex justify-center">
            <img
              src={`${getBaseUrl()}/static/people/andrey.jpg`}
              alt="Andrey Vital"
              className="h-16 w-16 rounded-3xl object-cover"
              width={64}
              height={64}
            />
          </div>

          <div
            css={{
              display: "grid",
              gridRowGap: 8,
            }}
          >
            <h4
              css={{
                margin: 0,
                color: palette.blueBayoux,
                fontWeight: "bold",
                fontSize: 16,
                lineHeight: 1.33,
                letterSpacing: 1.4,
              }}
            >
              Andrey Vital
            </h4>

            <p
              css={{
                margin: 0,
                color: palette.blueBayoux,
                fontSize: 14,
                fontStyle: "italic",
                lineHeight: 1.66,
                letterSpacing: 1,
              }}
            >
              Desenvolvedor de Software há mais de 9 anos. Trabalhou em empresas como Toptal, ClassDojo, DigitalRelab,
              VNA Group e atualmente está focado em criar o melhor site de análise fundamentalista do mundo.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
